import Vue from "vue";
import { arrayToObj } from "@/lib/utilities/index.js";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    allRoles: [],
    editingRole: {},
    showEditRoleModal: false,
    AlertMinerRoles: []
  };
}

function addRoleToList(state, role) {
  let index =
    state.allRoles && state.allRoles.length > 0
      ? state.allRoles.findIndex(item => item.Id == role.Id)
      : -1;
  if (index > -1) state.allRoles.splice(index, 1, role);
  else state.allRoles.push(role);
}

const state = initialState();

const actions = {
  getRolesToManage: function(context) {
    var vm = this;
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/rolepermissions/manageroles")
        .then(function(data) {
          context.commit("setRolesToManage", data);
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEditingRole: function(context, id) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/rolepermissions/getpermissionsforrole/" + id)
        .then(function(data) {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveRole: function(context, role) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/rolepermissions/saverole", role)
        .then(function(data) {
          context.commit("handleSaveRoleResponse", data);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteRole: function(context, id) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete("/rolepermissions/deleterole?roleId=" + id)
        .then(function(data) {
          context.commit("handleDeleteRoleResponse", {
            RoleId: id,
            Response: data
          });
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAlertminerRoles: function(context, platformId) {
    return new Promise(resolve => {
      Vue.http.get("/rolePermissions/GetAlertMinerRoles").then(resp => {
        HelperFunctions.getOrLoadDealerPackage(platformId).then(
          packageResponse => {
            let response = [];
            if (
              packageResponse &&
              packageResponse.Name &&
              packageResponse.Name.toLowerCase() == "activate"
            ) {
              response =
                resp && resp.data && resp.data.Data
                  ? resp.data.Data.filter(data => data.IsActive)
                  : [];
            } else if (resp && resp.data && resp.data.Data) {
              response = resp.data.Data.filter(
                data =>
                  !data.Name.toLowerCase().includes("activate") && data.IsActive
              );
            }
            context.commit("updateAlertMinerRoles", response);
            resolve(response);
          }
        );
      });
    });
  },
  getOriginalAlertMinerRoles: function() {
    return Vue.http
      .get("/rolepermissions/getoriginalalertminerroles")
      .then(resp => {
        if (resp && resp.data) return resp.data;
        return [];
      });
  }
};

const mutations = {
  setRolesToManage(state, data) {
    state.allRoles = data && data.data && data.data.Data ? data.data.Data : [];
  },
  handleSaveRoleResponse(state, data) {
    if (data && data.data && data.data.Success && data.data.Data) {
      let role = data.data.Data;
      let index =
        state.allRoles && state.allRoles.length > 0
          ? state.allRoles.findIndex(item => item.Id == role.Id)
          : -1;
      if (index > -1) state.allRoles.splice(index, 1, role);
      else state.allRoles.push(role);
    }
  },
  handleDeleteRoleResponse(state, data) {
    // Remove the deleted role from store
    let roleId = data.RoleId;
    let response = data.Response;

    if (
      response &&
      response.data &&
      response.data.Success &&
      state.allRoles &&
      state.allRoles.length > 0
    ) {
      let index = state.allRoles.findIndex(item => item.Id == roleId);
      if (index > -1) state.allRoles.splice(index, 1);
    }
  },
  toggleEditRoleModal: function(state, data) {
    state.showEditRoleModal = data;
  },
  setEditingRole: function(state, data) {
    state.editingRole = data;
  },
  updateAlertMinerRoles: function(state, data) {
    state.AlertMinerRoles = data;
  }
};

const getters = {
  allRoles(state) {
    return state.allRoles;
  },
  showEditRoleModal: function() {
    return state.showEditRoleModal;
  },
  editingRole: function() {
    return state.editingRole;
  },
  AlertMinerRoles: function() {
    return state.AlertMinerRoles;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Roles.js